import gsap from 'gsap';
import { Swiper, Navigation } from 'swiper';

Swiper.use(Navigation);

const primaryItems = '.collapse .primary__menu > .nav-item';
const secondaryItems = '.collapse .secondary__menu > li, .collapse .secondary__menu > .nav-item';

/* ------------------------------ Menu ------------------------------ */

const openMenuTl = gsap.timeline({ paused: true });

openMenuTl
    .set('.collapse', { display: 'block' })
    .fromTo('.collapse',
        { y: '-100%' },
        { y: '0%', duration: 0.55, ease: 'power3.out' }
    )
    .fromTo('.collapse__bottom',
        { opacity: 0, y: -10 },
        { opacity: 1, y: 0, duration: 0.35, ease: 'power2.out' },
        '-=0.2'
    )
    .fromTo(primaryItems,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.45, stagger: 0.08, ease: 'power2.out' },
        '-=0.3'
    )
    .fromTo(secondaryItems,
        { opacity: 0, y: 16 },
        { opacity: 1, y: 0, duration: 0.35, stagger: 0.045, ease: 'power2.out' },
        '<'
    );

const closeMenuTl = gsap.timeline({ paused: true });

closeMenuTl
    .to(`.collapse__bottom, ${primaryItems}, ${secondaryItems}`, {
        opacity: 0,
        duration: 0.18,
        ease: 'power2.in',
    })
    .to('.collapse', {
        y: '-100%',
        duration: 0.45,
        ease: 'power3.in',
    }, '-=0.05')
    .set('.collapse', { display: 'none' });

/* ----------------------------- Search ----------------------------- */

const openSearchTl = gsap.timeline({ paused: true });

openSearchTl
    .set('.search-collapse', { display: 'block' })
    .fromTo('.search-collapse',
        { y: '-100%' },
        { y: '0%', duration: 0.55, ease: 'power3.out' }
    );

const closeSearchTl = gsap.timeline({ paused: true });

closeSearchTl
    .to('.search-collapse', {
        y: '-100%',
        duration: 0.45,
        ease: 'power3.in',
    })
    .set('.search-collapse', { display: 'none' });

/* ----------------------------- Helpers ----------------------------- */

const restartTimeline = (timeline) => {
    timeline.restart();
}

const lockBodyScroll = (locked) => {
    if (locked) {
        window.scroll_position = $(window).scrollTop();
        $('body')
            .css('position', 'fixed')
            .css('top', `-${window.scroll_position}px`)
            .css('width', '100%');
    } else {
        $('body')
            .css('position', '')
            .css('top', '')
            .css('width', '');
        if (typeof window.scroll_position !== 'undefined') {
            $(window).scrollTop(window.scroll_position);
        }
    }
}

const closeAll = () => {
    if ($('body').hasClass('menu-open')) {
        restartTimeline(closeMenuTl);
        $('body').removeClass('menu-open').addClass('menu-closed');
    }
    if ($('body').hasClass('search-open')) {
        restartTimeline(closeSearchTl);
        $('body').removeClass('search-open');
    }
    $('.navbar-toggler').addClass('collapsed');
    lockBodyScroll(false);
}

const openMenu = () => {
    closeAll();
    restartTimeline(openMenuTl);
    $('body').addClass('menu-open').removeClass('menu-closed');
    $('.navbar-toggler').removeClass('collapsed');
    lockBodyScroll(true);
}

const openSearch = () => {
    closeAll();
    restartTimeline(openSearchTl);
    $('body').addClass('search-open');
    $('.navbar-toggler').removeClass('collapsed');
    lockBodyScroll(true);
    setTimeout(() => {
        $('.search-collapse__input').trigger('focus');
    }, 350);
}

/* ----------------------------- Events ------------------------------ */

$(document).on('click', '.navbar-toggler', function () {
    if ($('body').hasClass('menu-open') || $('body').hasClass('search-open')) {
        closeAll();
    } else {
        openMenu();
    }
});

$(document).on('click', '.header__search', function (e) {
    e.preventDefault();
    if ($('body').hasClass('search-open')) {
        closeAll();
    } else {
        openSearch();
    }
});

$(document).keydown(function (event) {
    if (event.keyCode == 27 && ($('body').hasClass('menu-open') || $('body').hasClass('search-open'))) {
        closeAll();
    }
});

/* ----------------------- Search results tabs ----------------------- */

$(document).on('click', '.search-collapse__tab', function () {
    const $tab = $(this);
    const target = $tab.data('tab');

    $tab.siblings('.search-collapse__tab').removeClass('is-active');
    $tab.addClass('is-active');

    $tab.closest('.search-collapse').find('.search-collapse__results').attr('data-active-tab', target);
});

/* ----------------------- Events Swiper ----------------------- */

let eventsSwipers = [];

const initEventsSwipers = () => {
    eventsSwipers.forEach((s) => {
        try { s.destroy(true, true); } catch (e) { /* noop */ }
    });
    eventsSwipers = [];

    document.querySelectorAll('[data-events-swiper]').forEach((el) => {
        const container = el.parentElement;
        const swiper = new Swiper(el, {
            spaceBetween: 15,
            watchOverflow: true,
            slidesPerView: 1.5,
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                },
            },
            navigation: {
                nextEl: container ? container.querySelector('[data-events-next]') : null,
                prevEl: container ? container.querySelector('[data-events-prev]') : null,
            },
        });
        eventsSwipers.push(swiper);
    });
};

/* ----------------------- Search AJAX ----------------------- */

const ajaxUrl = (window.ajaxvars && window.ajaxvars.ajax_url) || '/wp-admin/admin-ajax.php';

const fetchSearch = (params) => {
    const body = new URLSearchParams();
    body.append('action', 'doorbrekers_search');
    Object.keys(params).forEach((k) => body.append(k, params[k]));

    return fetch(ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
    }).then((r) => r.json());
};

const renderSearchResults = (data) => {
    const $results = $('[data-search-results]');
    const $tabs    = $('[data-search-tabs]');
    const $empty   = $('[data-search-empty]');

    let activeTab = $tabs.find('.search-collapse__tab.is-active').data('tab') || 'all';

    $results.empty();

    const buckets = data.buckets || {};
    const order = ['informatie', 'preken', 'blogs', 'events'];
    const filledBuckets = [];

    order.forEach((key) => {
        const bucket = buckets[key];
        if (bucket && bucket.html) {
            $results.append(bucket.html);
            filledBuckets.push(key);
        }
    });

    const anyResults = filledBuckets.length > 0;

    // Toggle tab visibility per bucket; "all" tab visible whenever there are results
    $tabs.find('.search-collapse__tab').each(function () {
        const $tab = $(this);
        const key = $tab.data('tab');
        if (key === 'all') {
            $tab.toggle(anyResults);
        } else {
            $tab.toggle(filledBuckets.indexOf(key) !== -1);
        }
    });

    // If the previously active tab no longer has results, fall back to "all"
    if (activeTab !== 'all' && filledBuckets.indexOf(activeTab) === -1) {
        activeTab = 'all';
        $tabs.find('.search-collapse__tab').removeClass('is-active');
        $tabs.find('[data-tab="all"]').addClass('is-active');
    }

    $results.attr('data-active-tab', activeTab);

    if (anyResults) {
        $results.removeAttr('hidden');
        $tabs.removeAttr('hidden');
        $empty.attr('hidden', true);
    } else {
        $results.attr('hidden', true);
        $tabs.attr('hidden', true);
        $empty.find('[data-search-empty-term]').text(data.term || '');
        $empty.removeAttr('hidden');
    }

    initEventsSwipers();

    const bucketEls = $results.find('.search-bucket').get();
    if (bucketEls.length) {
        gsap.fromTo(
            bucketEls,
            { opacity: 0, y: 24 },
            { opacity: 1, y: 0, duration: 0.45, stagger: 0.08, ease: 'power2.out' }
        );
    }
};

const clearSearchResults = () => {
    $('[data-search-results]').empty().attr('hidden', true);
    $('[data-search-tabs]').attr('hidden', true);
    $('[data-search-empty]').attr('hidden', true);
};

$(document).on('submit', '[data-search-form]', function (e) {
    e.preventDefault();

    const term = ($(this).find('[data-search-input]').val() || '').trim();
    if (!term) {
        clearSearchResults();
        return;
    }

    const $loader = $('[data-search-loader]');
    $loader.removeAttr('hidden');

    fetchSearch({ s: term })
        .then((data) => {
            renderSearchResults(data);
        })
        .catch((err) => {
            console.error('[search] error', err);
        })
        .finally(() => {
            $loader.attr('hidden', true);
        });
});

/* ----------------------- Load more per bucket ----------------------- */

$(document).on('click', '[data-load-more]', function (e) {
    e.preventDefault();

    const $btn      = $(this);
    const bucket    = $btn.data('load-more');
    const $section  = $btn.closest('.search-bucket');
    const $list     = $section.find('[data-bucket-list], [data-events-track]').first();
    // Op de zoekpagina (?s=) staat de zoekterm op de resultatenlijst
    const term      = ($section.closest('[data-search-term]').attr('data-search-term') || $('[data-search-input]').val() || '').trim();
    const loaded    = parseInt($section.attr('data-loaded'), 10) || 0;
    const total     = parseInt($section.attr('data-total'), 10) || 0;

    if (!term || loaded >= total) return;

    $btn.addClass('is-loading');

    fetchSearch({ s: term, bucket: bucket, offset: loaded })
        .then((data) => {
            const result = (data.buckets && data.buckets[bucket]) || null;
            if (!result || !result.html) return;

            $list.append(result.html);
            const newLoaded = loaded + (result.loaded || 0);
            $section.attr('data-loaded', newLoaded);

            if (newLoaded >= (result.total || total)) {
                $btn.remove();
            }
        })
        .catch((err) => {
            console.error('[search] load more error', err);
        })
        .finally(() => {
            $btn.removeClass('is-loading');
        });
});

/* ----------------------- Zoekpagina (?s=) ----------------------- */

if (document.querySelector('.search-page [data-events-swiper]')) {
    initEventsSwipers();
}
